import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
  FormArray,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgToastService } from 'ng-angular-popup';
import { RfiService } from '@/app/services/rfi/rfi.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { BriefSectionComponent } from '../../../project-development/tendering/project-expression-of-interest/brief-section/brief-section.component';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { FileManagerComponent } from '@/app/components/shared/file-manager/file-manager.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { DateFormatService } from '@/app/services/date-format.service';
@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    BriefSectionComponent,
    RichTextEditorComponent,
    FileManagerComponent,
    MatDatepickerModule,
  ],
  providers: [provideNativeDateAdapter()],
  selector: 'app-add-rfi',
  templateUrl: './add-rfi.component.html',
  styleUrls: ['./add-rfi.component.css'],
})
export class AddRfiComponent implements OnInit, OnChanges {
  @ViewChild('addRfiDialog') addRfiDialog!: TemplateRef<any>;
  @Input() isDialogOpen!: boolean;
  @Output() loadRfiData = new EventEmitter<any>();
  rfiId: any;
  projectName: string;
  projectIdentifier: string;
  editRFIId: number;
  projectId: number;
  resetRichTextEditor = false;
  oldRfiFiles = [];
  deletedOldRfiFiles = [];

  rfiForm = new FormGroup({
    subject: new FormControl('', Validators.required),
    issue: new FormControl(''),
    clarification: new FormControl(''),
    responseDate: new FormControl(''),
    recommendation: new FormControl(''),
    rfiFiles: new FormArray([]),
  });
  currentStep = 1;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private toast: NgToastService,
    private rfiService: RfiService,
    private router: Router,
    private route: ActivatedRoute,
    private getProjectIdService: GetProjectIdService,
    private dateService: DateFormatService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
    this.projectId = +this.getProjectIdService.getProjectId();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isDialogOpen'] && !changes['isDialogOpen'].firstChange) {
      this.rfiForm.reset();
      this.openAddRfiDialog();
    }
  }
  openAddRfiDialog() {
    this.dialog.open(this.addRfiDialog, {
      disableClose: true,
      autoFocus: false,
    });
  }
  closeDialog() {
    this.dialog.closeAll();
  }
  // Handle RFI form submission
  async createRFI() {
    const dataToSubmit: any = await this.prepareRFIDataToSubmit();
    if (!dataToSubmit) return;
    console.log('The dataToSubmit', dataToSubmit);
    this.rfiService.createRfi(dataToSubmit).subscribe({
      next: (response: any) => {
        if (response.meta.success) {
          this.toast.success('RFI added successfully', 'SUCCESS', 4000);
          this.rfiForm.reset();
          this.closeDialog();
          this.router.navigate(
            ['/contractor/rfi-view', this.projectId, response?.data?.id],
            {
              queryParams: {
                projectName: this.projectName,
                projectIdentifier: this.projectIdentifier,
              },
            }
          );
        }
      },
      error: (error: any) => {
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });
  }
  async prepareRFIDataToSubmit() {
    if (this.rfiForm.invalid) {
      this.toast.warning('Please fill all required fields.', 'WARNING', 4000);
      this.rfiForm.markAllAsTouched();
      return;
    }
    const dataToSubmit = new FormData();

    dataToSubmit.append('title', 'test title');
    dataToSubmit.append('subject', this.rfiForm.value.subject);
    dataToSubmit.append('clarification', this.rfiForm.value.clarification);
    dataToSubmit.append('recommendation', this.rfiForm.value.recommendation);
    dataToSubmit.append('issue', this.rfiForm.value.issue);
    dataToSubmit.append(
      'response_date',
      this.dateService.formatDate(this.rfiForm.value.responseDate)
    );
    dataToSubmit.append(
      'issue_date',
      this.dateService.formatDate(this.rfiForm.value.responseDate)
    );

    this.addUploadedFiles(dataToSubmit);
    this.addDeletedOldFilesIds(dataToSubmit);
    return dataToSubmit;
  }
  addDeletedOldFilesIds(submissionFormData) {
    if (this.deletedOldRfiFiles?.length > 0) {
      submissionFormData.append(
        'deletedOldRfiFilesIds',
        JSON.stringify(this.deletedOldRfiFiles)
      );
    }
  }
  addUploadedFiles(submissionFormData) {
    this.rfiForm.value.rfiFiles.forEach((uploadedFile: File) => {
      if (uploadedFile) {
        submissionFormData.append(
          'referenced_concerning_attach[]',
          uploadedFile
        );
      }
    });
  }

  nextStep() {
    if (this.currentStep < 4) {
      this.currentStep++;
    }
  }
  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }
  addClarification(content: string) {
    this.rfiForm.controls['clarification'].setValue(content);
  }
  addIssue(content: string) {
    this.rfiForm.controls['issue'].setValue(content);
  }
  addRecommendation(content: string) {
    this.rfiForm.controls['recommendation'].setValue(content);
  }
  handleDeletedOldFiles(OldFileData: any) {
    switch (OldFileData.controlName) {
      case 'rfiFiles': {
        this.deletedOldRfiFiles.push(OldFileData?.file?.id);
        this.oldRfiFiles = this.oldRfiFiles.filter(
          (file) => file.id !== OldFileData?.file?.id
        );
        break;
      }
      default:
        break;
    }
  }
  handleNewFiles(filesData: {
    files: File[];
    controlName: string;
    isEmpty: boolean;
  }) {
    switch (filesData.controlName) {
      case 'rfiFiles': {
        const fileArray = this.rfiForm.get('rfiFiles') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) {
          break;
        }
        filesData.files.forEach((file) =>
          fileArray.push(new FormControl(file))
        );
        break;
      }

      default:
        break;
    }
  }
}
